import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useEffect, useState } from 'react'
import { DrawerContext } from '../hooks/useDrawer'
import { miniDrawerBreakpoint } from '../store/constant'

export function DrawerProvider({ children }: { children: React.ReactNode }) {
  const [drawerOpen, setDrawerOpen] = useState(true)
  const theme = useTheme()
  const isMiniDrawer = useMediaQuery(
    theme.breakpoints.down(miniDrawerBreakpoint),
  )

  useEffect(() => {
    if (isMiniDrawer) {
      setDrawerOpen(false)
    }
  }, [isMiniDrawer])

  function handlerDrawerOpen() {
    setDrawerOpen((prev) => !prev)
  }

  const isDrawerExpanded: boolean = drawerOpen

  return (
    <DrawerContext.Provider
      value={{ drawerOpen, handlerDrawerOpen, isDrawerExpanded, isMiniDrawer }}
    >
      {children}
    </DrawerContext.Provider>
  )
}
